import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import dropDownIcon from '../../../assets/images/dropDownIcon.svg';
import disabledDropDownIcon from '../../../assets/images/dropDownIcon_disabled.svg';
import styles from './styles/styles.module.css';

function PayPeriodSelector({ options, value, onChange, disabled }) {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const current = options.find((option) => option.value === value) || options[0];

  const toggleMenu = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
  };

  const handleOptionSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Если селектор заблокировали при открытом меню - оно не показывается.
  const isMenuOpen = isOpen && !disabled;

  return (
    <div className={styles.payPeriodDropdownWrapper} ref={dropdownRef}>
      <button
        type="button"
        className={`${styles.payPeriodSelector} ${disabled ? '' : styles.payPeriodSelector_active}`}
        onClick={toggleMenu}
        disabled={disabled}
        aria-haspopup="true"
        aria-expanded={isMenuOpen}
      >
        <span>{current.label}</span>
        <span className={styles.optionMeta}>
          {current.badge ? (
            <span
              className={`${styles.discountBadge} ${disabled ? styles.discountBadge_disabled : ''}`}
            >
              {current.badge}
            </span>
          ) : null}
          <img
            className={`${styles.openMenuIcon} ${isMenuOpen ? styles.openMenuIcon_active : ''}`}
            src={disabled ? disabledDropDownIcon : dropDownIcon}
            alt=""
          />
        </span>
      </button>
      {isMenuOpen && (
        <ul className={styles.payPeriodDropdownMenu}>
          {options.map((option) => (
            <li key={option.value} className={styles.payPeriodDropdownItem}>
              <button
                type="button"
                onClick={() => handleOptionSelect(option.value)}
                className={
                  option.value === current.value ? styles.itemSelected : undefined
                }
                aria-current={option.value === current.value}
              >
                <span>{option.label}</span>
                <span className={styles.optionMeta}>
                  {option.badge ? (
                    <span className={styles.discountBadge}>{option.badge}</span>
                  ) : null}
                  <span className={styles.optionPrice}>{option.price}</span>
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PayPeriodSelector;

PayPeriodSelector.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      price: PropTypes.string,
      badge: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
